import { AccordionDetails } from '@mui/material'
import PropTypes from 'prop-types'
import React, { memo, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { selectSelectedAsset } from '../../../../store/redusers/assets/selectors'
import AssetsItem from '../AssetsItem/AssetsItem'

const AssetsAccordionDetails = memo(({
	onHandleClickAsset,
	assetsSoIdes,
	assetType,
	setIsScrollBar
}) => {
	const ref = useRef()
	const active = useSelector(selectSelectedAsset) || ''

	useEffect(() => {
		const div = ref.current
		setIsScrollBar(div.scrollHeight !== div.offsetHeight)
	},[assetType])

	return (
		<AccordionDetails ref={ref} sx={{maxHeight: 450, overflow: 'auto'}}>
			{!assetsSoIdes ? null :
				assetsSoIdes.map((assetSoId, index) => {
					return (
						<AssetsItem
							onHandleClickAsset={onHandleClickAsset}
							key={assetSoId + index}
							assetSoId={assetSoId}
							assetType={assetType}
							active={active.assetSoId === assetSoId}
						/>
					)
				})
			}
		</AccordionDetails>
	)
})

AssetsAccordionDetails.propTypes = {
	assetType: PropTypes.string,
	assetsSoIdes: PropTypes.array,
	onHandleClickAsset: PropTypes.func,
	setIsScrollBar: PropTypes.func
}

AssetsAccordionDetails.displayName = 'AssetsAccordionDetails'

export default AssetsAccordionDetails
